module.exports = __webpack_public_path__ + "images/header-loading-logo.d73159084f5122775d4d.gif";